import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type CompanyName = string;
type Color = string;

export type CompaniesPieColors = Record<CompanyName, Color>;

export interface CompaniesPieColorsState {
  pieColors: CompaniesPieColors;
}

const initialState: CompaniesPieColorsState = {
  pieColors: {},
};

export const companiesPieColorsSlice = createSlice({
  name: 'companiesPieColors',
  initialState,
  reducers: {
    updatePieColors: (state, action: PayloadAction<CompaniesPieColors>) => {
      state.pieColors = {
        ...state.pieColors,
        ...action.payload,
      };
    },
  },
});
